import { render, staticRenderFns } from "./GroupConsentDetail.vue?vue&type=template&id=62e3293b&scoped=true&"
import script from "./GroupConsentDetail.vue?vue&type=script&lang=js&"
export * from "./GroupConsentDetail.vue?vue&type=script&lang=js&"
import style0 from "./GroupConsentDetail.vue?vue&type=style&index=0&id=62e3293b&prod&lang=css&"
import style1 from "./GroupConsentDetail.vue?vue&type=style&index=1&id=62e3293b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e3293b",
  null
  
)

export default component.exports